import React from 'react';

export const NoDryIcon = ({ className = '' }) => (
  <svg
    className={className}
    width="28"
    height="26"
    viewBox="0 0 28 26"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M22.5 1L20.7521 5.10935C19.6765 7.63818 20.1064 10.5563 21.8657 12.6674V12.6674C23.7629 14.9441 24.1018 18.1395 22.7242 20.7634L20.5 25M6.5 1L4.7521 5.10935C3.67647 7.63818 4.10642 10.5563 5.8657 12.6674C7.38032 14.485 7.90172 16.888 7.34951 19.1184M4.5 25L6.72421 20.7634C7.00201 20.2343 7.21002 19.6819 7.34951 19.1184M14.5 1L12.7521 5.10935C11.6765 7.63818 12.1064 10.5563 13.8657 12.6674C13.9378 12.7539 14.0076 12.8417 14.0752 12.9308M12.5 25L14.7242 20.7634C16.0494 18.2392 15.7862 15.1861 14.0752 12.9308M1.09677 24.871L7.34951 19.1184M7.34951 19.1184L14.0752 12.9308M14.0752 12.9308L26.9032 1.12903"
      stroke="url(#paint0_linear)"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <defs>
      <linearGradient
        id="paint0_linear"
        x1="7.00559"
        y1="17.9606"
        x2="28.1857"
        y2="11.1018"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#C49E19" />
        <stop offset="1" stopColor="#F5C518" />
      </linearGradient>
    </defs>
  </svg>
);
